import { useLocationPathname, useLocationSearch, useNavigate } from '@rocketlane/rocket-router';
import { parse, stringify } from 'query-string';
import { useCallback } from 'react';
import { useTaskDrawerSetVisibility } from 'contexts/providers/task-pane';
import { isCustomerPortal } from 'utils/portal-utils';
// import { fetchTask } from 'collections/tasks';
// import { getTaskDetailQueryKey } from 'queries/task';
export var TaskDrawerTab = /*#__PURE__*/ function(TaskDrawerTab) {
    TaskDrawerTab["Conversations"] = "conversations";
    TaskDrawerTab["Approvals"] = "approvals";
    return TaskDrawerTab;
}({});
export const stringifyTaskDrawerParam = ([, projectId, taskId])=>{
    return [
        projectId,
        taskId
    ].join('.');
};
const getGroupsFromString = (str)=>{
    var _str_match;
    return (_str_match = str.match(/^(?<project_id>\d+)\.(?<task_id>\d+)$/)) === null || _str_match === void 0 ? void 0 : _str_match.groups;
};
export const parseTaskDrawerParam = (str)=>{
    var _groups_project_id, _groups_task_id;
    const groups = getGroupsFromString(str);
    if (!groups) {
        return groups;
    }
    const project_id = parseInt((_groups_project_id = groups.project_id) !== null && _groups_project_id !== void 0 ? _groups_project_id : '', 10);
    const task_id = parseInt((_groups_task_id = groups.task_id) !== null && _groups_task_id !== void 0 ? _groups_task_id : '', 10);
    return {
        project_id,
        task_id
    };
};
const getDrawerTab = (params)=>{
    switch(params.tab){
        case "approvals":
            return {
                task_drawer_tab: "approvals",
                show_new_approval: params.showNewApproval
            };
        case "conversations":
        default:
            return {
                task_drawer_tab: "conversations"
            };
    }
};
export const getTaskDetailUrl = (taskId, params, currentUrlHash)=>{
    const baseHash = {
        task_drawer: stringifyTaskDrawerParam(taskId)
    };
    const parsedCurrentUrlHash = currentUrlHash ? parse(currentUrlHash) : {};
    delete parsedCurrentUrlHash.notifications;
    const hash = {
        ...parsedCurrentUrlHash,
        ...baseHash,
        ...getDrawerTab(params)
    };
    return `#${stringify(hash, {
        sort: false
    })}`;
};
export const getSpaceUrl = (projectId, spaceId, sourceId)=>{
    return `projects/${projectId}/spaces/${spaceId}/tabs/${sourceId}?tab=approvals`;
};
export const defaultParams = {
    tab: "conversations"
};
export const useNavigateToTask = ()=>{
    const push = useNavigate();
    const pathname = useLocationPathname();
    const search = useLocationSearch();
    const setVisibility = useTaskDrawerSetVisibility();
    return useCallback((taskId, params = defaultParams, path = pathname)=>{
        setVisibility(true);
        push({
            pathname: path,
            search,
            hash: getTaskDetailUrl(taskId, params, window.location.hash)
        }, {
            state: {
                fromTaskOpen: isCustomerPortal()
            }
        });
    // queryClient.prefetchQuery({
    //   queryKey: getTaskDetailQueryKey(taskId),
    //   queryFn: () => fetchTask(taskId[1], taskId[2]),
    // });
    }, [
        pathname,
        setVisibility,
        push,
        search
    ]);
};
export const useNavigateToSpace = ()=>{
    return useCallback((projectId, spaceId, sourceId)=>{
        window.open(getSpaceUrl(projectId, spaceId, sourceId), '_blank', 'noopener');
    }, []);
};
